import * as React from 'react'
import { AIDA_ICON_HOVER_QUERY } from './aida-icon-animated-paths'

export function useIconActivity(svgRef: React.RefObject<SVGSVGElement | null>) {
  const [canHover, setCanHover] = React.useState(false)
  const [pageVisible, setPageVisible] = React.useState(true)
  const [onScreen, setOnScreen] = React.useState(false)

  React.useEffect(() => {
    const query = window.matchMedia(AIDA_ICON_HOVER_QUERY)
    const sync = () => setCanHover(query.matches)
    sync()
    query.addEventListener('change', sync)
    return () => query.removeEventListener('change', sync)
  }, [])

  React.useEffect(() => {
    const sync = () => setPageVisible(document.visibilityState === 'visible')
    sync()
    document.addEventListener('visibilitychange', sync)
    return () => document.removeEventListener('visibilitychange', sync)
  }, [])

  React.useEffect(() => {
    const node = svgRef.current
    if (!node) {
      return
    }
    const observer = new IntersectionObserver(([entry]) => {
      setOnScreen(entry?.isIntersecting ?? false)
    })
    observer.observe(node)
    return () => observer.disconnect()
  }, [svgRef])

  return { canHover, pageVisible, onScreen }
}
